import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { WalletContainer, WalletHeader } from "../../../auth/wallet/walletStyles";
import { Box, Button, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import PinComponent from "../../../auth/wallet/PinComponent";
import SuccessModal from "../../../components/SuccessModal";
import { deductPaymentFromUserWallet, moveUserFunds, walletType } from "../../dashboard/DashboardUtils";
import { toast } from "react-toastify";
import {
	clearDeductWalletSuccess,
	clearMoveFundsSuccess,
	deductFromWalletSuccess,
	moveFundsSuccess,
} from "../../../redux/WalletSlice";
import { useNavigate } from "react-router-dom";
import { updateAdminCreatedRequest } from "../utils";
import { toggleActivateRequestModal } from "../ApprenticeshipSlice";

const ActivateAdminRequest = ({ activateAssetTab, setActivateAssetTab, requestData }) => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const { adminWallet, walletDetails, deductWalletMessage, moveFundsMessage } = useSelector(
		(state) => state.wallet
	);

	const [loading, setLoading] = useState(false);
	const [updatedData, setUpdatedData] = useState(null);

	const mainWallet = adminWallet?.find((wallet) => wallet?.product === walletType.main);

	const fee = process.env.NODE_ENV !== "production" ? 1 : 100;

	const amount = requestData?.amountToInvest;

	const amountPayable = fee + Number(amount?.replaceAll(",", ""));

	const onCloseModal = () => {
		dispatch(toggleActivateRequestModal(false));
	};

	// DEDUCT ASSET FEE FROM WALLET
	const onDeductWallet = async () => {
		const details = {
			walletId: walletDetails?.id,
			amount: fee,
			narration: "asset-activation-fee",
		};

		if (mainWallet?.availableBalance < amountPayable) {
			toast.error("Insuffient balance. Please fund your wallet!");
			return;
		}

		try {
			setLoading(true);
			const data = await deductPaymentFromUserWallet(details, "asset-activation-fee-successful");
			console.log(data);
			dispatch(deductFromWalletSuccess(data));
		} catch (error) {
			toast.error(error);
		} finally {
			setLoading(false);
		}
	};

	// FUNCTION TO MOVE FUNDS TO LEASE INVESTMENT
	const moveFundsBetweenWallets = async (details) => {
		setLoading(true);
		try {
			const data = await moveUserFunds(details);
			dispatch(moveFundsSuccess(data));
			console.log(data);
		} catch (error) {
			if (error === "This session has expired. Please Login again") {
				navigate("/login");
			} else {
				toast.error(error);
			}
		} finally {
			setLoading(false);
		}
	};

	// FUNCTION TO UPDATE ASSET IN PARSE
	const onUpdateAssetInParse = async (id, data) => {
		setLoading(true);
		try {
			const res = await updateAdminCreatedRequest(id, data);
			setUpdatedData(res);
			console.log(res);
		} catch (error) {
			toast.error(error);
		} finally {
			setLoading(false);
		}
	};

	// ON PROCEED TO ACTIVE ASSETS
	const onProceedToActiveAssets = () => {
		dispatch(toggleActivateRequestModal(false));
		navigate("/apprenticeship/active/?filter=quick_finance");
	};

	useEffect(() => {
		if (deductWalletMessage === "asset-activation-fee-successful") {
			dispatch(clearDeductWalletSuccess());

			const details = {
				amount: String(amount),
				source: "main",
				destination: walletType.leaseInvestment,
				message: "investor-slot-payment-for-created-finance",
			};

			console.log(details);

			moveFundsBetweenWallets(details);
		} else {
			return;
		}
	}, [deductWalletMessage]);

	useEffect(() => {
		if (moveFundsMessage === "investor-slot-payment-for-created-finance") {
			dispatch(clearMoveFundsSuccess());

			const data = {
				funded: true,
				status: "active",
			};

			onUpdateAssetInParse(requestData?.objectId, data);
		} else {
			return;
		}
	}, [moveFundsMessage]);

	useEffect(() => {
		if (updatedData) {
			setActivateAssetTab(3);
		} else {
			return;
		}
	}, [updatedData]);

	return (
		<>
			{activateAssetTab === 1 && (
				<WalletContainer>
					<>
						<WalletHeader
							headerText='Activate Asset'
							context='Activate and list asset on market place.'
							onCloseModal={onCloseModal}
						/>
						<Typography
							marginY={2}
							color='black'>{`NGN ${amountPayable.toLocaleString()} ( N${fee} "activation fee" ) will be deducted from the admin wallet to activate and list this request on the market place.`}</Typography>
						<Box display='grid' gridTemplateColumns='1fr 1fr' gap={2}>
							<Button variant='outlined' color='error' onClick={onCloseModal}>
								cancel
							</Button>
							<Button variant='contained' color='primary' onClick={() => setActivateAssetTab(2)}>
								proceed
							</Button>
						</Box>
					</>
				</WalletContainer>
			)}
			{activateAssetTab === 2 && (
				<PinComponent onClose={onCloseModal} onDeductFunds={onDeductWallet} isLoading={loading} />
			)}
			{activateAssetTab === 3 && (
				<SuccessModal
					modalText={`The amount of N${amountPayable.toLocaleString()} has been deducted and asset has been activated for leasing.`}
					btnText='proceed'
					onReqClick={onProceedToActiveAssets}
				/>
			)}
		</>
	);
};

export default ActivateAdminRequest;

ActivateAdminRequest.propTypes = {
	activateAssetTab: PropTypes.number,
	setActivateAssetTab: PropTypes.func,
	requestData: PropTypes.object,
};
